export default () => ({
  message: null,
  jobs: [],
  categories: [],
});
